<template>
  <el-select
    placeholder="Sélectionner un statut"
    :value="value"
    :disabled="disabled"
    @change="$emit('input', $event)"
  >
    <slot />
    <el-option
      v-for="status in statuses"
      :key="status"
      :value="status"
      :label="$t(`schoolLists.statuses.${status}`)"
    >
    </el-option>
  </el-select>
</template>

<script>
import { mapState } from 'vuex'

export default {
  props: {
    value: {
      type: String,
      default: null,
    },
    types: {
      type: Array,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState('schoolLists', ['statuses']),
  },
}
</script>
